import React from "react";
import { Row, Col, Container } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import styled from "styled-components";
import { CrearMensajesChat, AdjuntarChats } from "../../API/Core";
import moment from "moment";
import socket from "../socketio/socketio";

export default function FuncionName(props) {
  const [mensaje, setMensaje] = React.useState("");

  const EnviarMensaje = async () => {
    let idprofesor = props.selected.profesor;
    let cedulaAlumno = props.selected.alumno;
    let idmateria = props.selected.materia;
    let reporte= props.reporte;
    let idasociar= props.idasociar
    let fechadia= props.fechadia
    //socket.emit("Profesores", { profesor: idprofesor, alumno: cedulaAlumno, materia: idmateria });

    let mensaje_ = mensaje;
    let response = await CrearMensajesChat(
      idprofesor,
      cedulaAlumno,
      idmateria,
      mensaje_,
      reporte,
      idasociar,
      fechadia,
    );
    if (response.data.variable1) {
      mensaje_ = {
        variable: "Profesor",
        variable2: mensaje,
        variable3: moment(),
        variable4: "0",
        variable5: String(props.selected.id),
      };
      setMensaje("");
      props.pushMessage(mensaje_);
    }
  };
  const Upload = async (e) => {
    //console.log(e.target.files);

    //console.log("ssss"+props.selected)
    // console.log("especialista "+props.selected.cedula_Especialista)
    // console.log("paciente "+props.selected.alumno)
    // console.log("sala "+props.selected.materia)
    // console.log("mensaje "+mensaje)
    // if (e.target.files > 0) {
    let idsala = props.selected.id;
    let reporte= props.reporte;
    let idasociar= props.idasociar
    let fechadia= props.fechadia
    let response = await AdjuntarChats(e, idsala, reporte, idasociar, fechadia);

    if (response.data.variable1) {
      let mensaje_ = {
        variable: "Profesor",
        variable2: response.data.variable2,
        variable3: moment(),
        variable4: "0",
        variable5: String(props.selected.id),
        variable6: response.data.variable3,
      };
      setMensaje("");
      props.pushMessage(mensaje_);
    }
    //}
  };

  const ClickUpload = (e) => {
    document.getElementById("upload-file").click();
  };
  return (
    <Row>
      <Col style={{ paddingRight: "0" }} xs="10">
        <MessageField
          className="form-control"
          id="mensaje"
          name="mensaje"
          autoComplete="off"
          value={mensaje}
          onChange={(e) => setMensaje(e.target.value)}
          onKeyPress={(event) => {
            if (event.key === "Enter") {
              EnviarMensaje();
            }
          }}
        />
      </Col>
      <Col style={{ paddingLeft: "0" }} className="text-center">
        <Send onClick={EnviarMensaje}>
          <FeatherIcon icon="send" stroke="#fff" size="18" />{" "}
        </Send>
      </Col>
      <Col style={{ paddingLeft: "0" }} className="text-center">
        <Send onClick={ClickUpload}>
          <FeatherIcon icon="download-cloud" stroke="#fff" size="18" />{" "}
          <input
            onChange={Upload}
            style={{ display: "none" }}
            id="upload-file"
            type="file"
            // multiple
          />
        </Send>
      </Col>
    </Row>
  );
}

const MessageField = styled.textarea`
  height: 80px;
  resize: none;
`;

const Send = styled.button`
  border-radius: 3px;
  width: 100%;
  height: 100%;
  border: solid 1px #eee;
  background-color: #028d7b;
  text-align: center;
  transition: all 0.3s;
  :hover {
    opacity: 0.8;
  }
  svg {
    width: 20px;
    stroke: #ffff;
  }
`;
